import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  margin-bottom: 3%;
`
export const SelectorContainer = styled.div`
  margin-top: -2%;
`

export const InsightsStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  margin-top: 20px;
`

export const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`

export const SummaryCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 18px 20px;
  border-radius: 22px;
  background: linear-gradient(180deg, #ffffff 0%, #f6fafe 100%);
  border: 1px solid #d8e4ef;
  box-shadow: 0px 16px 32px rgba(45, 116, 156, 0.08);
`

export const SummaryLabel = styled.span`
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #74839a;
`

export const SummaryValue = styled.strong`
  font-size: 24px;
  line-height: 1.2;
  color: #21354a;
`

export const SummaryHint = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.55;
  color: #5f738a;
`

export const EnvironmentBanner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 18px 22px;
  border-radius: 24px;
  background: linear-gradient(90deg, rgba(198, 1, 107, 0.06) 0%, rgba(45, 116, 156, 0.12) 100%);
  border: 1px solid rgba(45, 116, 156, 0.16);
`

export const EnvironmentTitle = styled.span`
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #6e7f95;
`

export const EnvironmentText = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 1.6;
  color: #27435b;
`

export const InsightSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px 22px;
  border-radius: 24px;
  background: #ffffff;
  border: 1px solid #e4edf5;
  box-shadow: 0px 14px 30px rgba(31, 33, 36, 0.06);
`

export const InsightSectionTitle = styled.h4`
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #21354a;
`

export const InsightPills = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`

export const InsightPill = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 14px;
  border-radius: 999px;
  background: #f3f8fc;
  border: 1px solid #dce8f2;
  font-size: 14px;
  line-height: 1.4;
  color: #36536d;
`

export const ContentCard = styled.div`
  margin-top: 18px;
  padding: 6px 0 0;
`

export const ContextNote = styled.div`
  margin-top: 16px;
  padding: 14px 18px;
  border-radius: 18px;
  background: linear-gradient(90deg, rgba(45, 116, 156, 0.08) 0%, rgba(45, 116, 156, 0.03) 100%);
  border: 1px solid rgba(45, 116, 156, 0.14);
`

export const ContextNoteText = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.55;
  color: #45627d;
`
